var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapZoom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7969 20.5234C11.5352 20.5234 12.1328 19.9141 12.1328 19.2227V11.8867H19.2812C19.9961 11.8867 20.6055 11.2891 20.6055 10.5508C20.6055 9.82422 19.9961 9.21484 19.2812 9.21484H12.1328V1.87891C12.1328 1.17578 11.5352 0.578125 10.7969 0.578125C10.0703 0.578125 9.46094 1.17578 9.46094 1.87891V9.21484H2.3125C1.62109 9.21484 0.988281 9.82422 0.988281 10.5508C0.988281 11.2891 1.62109 11.8867 2.3125 11.8867H9.46094V19.2227C9.46094 19.9141 10.0703 20.5234 10.7969 20.5234Z",
    fill: "#00233D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapZoom);
export default __webpack_public_path__ + "static/media/map-zoom.ccd6b3de5aeaf4d7930fa9fd89306ba6.svg";
export { ForwardRef as ReactComponent };